import { useEffect, useState } from "react";

type Promotion = {
  id: string;
  kind: "ad" | "cps" | "sponsor" | "referral" | "donation";
  provider: string;
  title: string;
  description: string;
  image_url: string;
  disclosure: string;
  clickUrl: string;
};

const kindNames: Record<Promotion["kind"], string> = {
  ad: "广告",
  cps: "好物推荐",
  sponsor: "品牌合作",
  referral: "服务推荐",
  donation: "支持项目",
};

export function MonetizationPlacement({ placement }: { placement: "home" | "tool" }) {
  const [items, setItems] = useState<Promotion[]>([]);
  useEffect(() => {
    let active = true;
    void fetch(`/api/monetization/items?placement=${placement}`)
      .then(async (response) => response.ok ? await response.json() as { items?: Promotion[] } : { items: [] })
      .then((data) => { if (active) setItems(data.items || []); })
      .catch(() => { if (active) setItems([]); });
    return () => { active = false; };
  }, [placement]);

  if (!items.length) return null;
  return (
    <section className="monetization-placement" aria-label="推荐与合作">
      <div className="monetization-heading"><h2>推荐与合作</h2></div>
      <div className="monetization-grid">
        {items.map((item) => (
          <a className="monetization-card" href={item.clickUrl} key={item.id} target="_blank" rel="sponsored noopener noreferrer">
            {item.image_url && <img src={item.image_url} alt="" loading="lazy" />}
            <span className="monetization-label">{kindNames[item.kind]}{item.provider ? ` · ${item.provider}` : ""}</span>
            <strong>{item.title}</strong>
            {item.description && <span className="monetization-description">{item.description}</span>}
            <small>{item.disclosure}</small>
          </a>
        ))}
      </div>
    </section>
  );
}
